
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { AuthenticationService } from '../../../../services/authenticationService';
import logger from '../../../../utils/logger';
import { setupTokenRefresh } from '../../../../helper/Axios/axiosHelper';
import { useDispatch } from 'react-redux';
import { setEnable } from '../../../../redux/slices/privateRouteAuthorizations';
import { scheduleTokenRefresh } from '../../../../helper/auth/tokenManagger';

export const useSubmitControler = () => {
    const dispatch = useDispatch()
    const [message, setMessage] = useState('')
    const [response, setResponse] = useState(null)
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "onBlur",
    })

    const onSubmit = async (data) => {
        try {
            // logger.info('data recibida: ', data)

            const responseLogin = await AuthenticationService.login(data)

            logger.info('response: ', responseLogin)

            // console.log(response);

            if (responseLogin.accessToken) {


                //console.log('response.accessToken', response.accessToken)
                const calculateExpiresAt = (expiresIn) => Math.floor(Date.now() / 1000) + expiresIn;
                const expiresAt = calculateExpiresAt(responseLogin.expiresIn);

                localStorage.setItem('access-token', responseLogin.accessToken)
                localStorage.setItem('refresh-token', responseLogin.refreshToken)
                localStorage.setItem('expire-in', expiresAt)
                localStorage.setItem('token-type', responseLogin.tokenType)


                //LISTA DEL MENÚ

                localStorage.setItem('menuOption', JSON.stringify(responseLogin.menu));

                dispatch(setEnable())

            }
            logger.info('llamada a setupTokenRefresh()')
            // setupTokenRefresh()
            scheduleTokenRefresh()
            setResponse(responseLogin);


            //console.log(response);
            //console.log('resultado ', result)
            // setMessage(result.data.message)

        } catch (error) {


            // setMessage(error.message)
            // setResponse(error.status)


            const status = error.response?.status || 'Error de red'
            const message = error.response?.data?.message || error.message

            setMessage(message)
            setResponse(status)
            logger.error('error login: ', error);
        }
    }



    return { register, handleSubmit, onSubmit, errors, message, response, setMessage, setResponse }
}

